import LoadingAnimation from "@assets/svg/LoadingAnimation";
import { Checkbox } from "@components/ui/checkbox";
import { Input } from "@components/ui/input";
import { getHiringCompanyMembers } from "@endpoints/hiringCompany/hiringCompany";
import { IHiringStaff } from "@type/hiringStaff.type";
import { HiringCompanyType } from "@utils/constants";
import { SearchIcon } from "lucide-react";
import React, { useEffect, useState } from "react";

const AddMembers: React.FC<any> = ({ setValue, watch }) => {
  const hiringTeamMembers = watch("hiringTeamMembers") || [];
  const [staffMembers, setStaffMembers] = useState<IHiringStaff[]>([]);
  const [isStaffMembersLoading, setIsStaffMembersLoading] = useState(false);

  async function fetchHiringCompanyMembers() {
    try {
      setIsStaffMembersLoading(true);
      const { success, data } = await getHiringCompanyMembers();
      if (success) {
        setStaffMembers(data?.members);
        console.log("hiring staff members", data);
      }
    } catch (error) {
      console.error("Error: fetching hiring company members", error);
    } finally {
      setIsStaffMembersLoading(false);
    }
  }

  function handleAddOrRemoveStaff(id: string) {
    let updatedHiringTeamMembers: { userId: string }[] =
      hiringTeamMembers || [];
    const idExist = updatedHiringTeamMembers?.find(
      (item) => item?.userId === id
    );
    if (idExist) {
      updatedHiringTeamMembers = updatedHiringTeamMembers?.filter(
        (item) => item?.userId !== id
      );
    } else {
      updatedHiringTeamMembers.push({ userId: id });
    }
    setValue("hiringTeamMembers", updatedHiringTeamMembers);
  }

  useEffect(() => {
    fetchHiringCompanyMembers();
  }, []);

  return (
    <React.Fragment>
      {isStaffMembersLoading || !staffMembers?.length ? (
        <div className="flex flex-col flex-1 justify-center items-center">
          {isStaffMembersLoading ? (
            <LoadingAnimation className="h-6 w-6" color="#2e2e2e" />
          ) : (
            <div className="flex flex-col items-center justify-center gap-2">
              <span className="font-medium text-sm text-light-black">
                No staff members available.
              </span>
            </div>
          )}
        </div>
      ) : (
        <div className="flex flex-col flex-1 gap-5 px-20">
          {/* Search container */}
          <div className="flex items-center justify-between bg-gray-100 rounded-md border px-5 py-2.5">
            <div className="flex items-center bg-white pr-3 border rounded-md w-2/3">
              <Input
                className="!focus-visible:ring-[3px] border-none !text-xs font-medium"
                placeholder="Search by agent name,reference..."
                // type="number"
              />
              <SearchIcon className="w-4 h-4" color="#2e2e2e" />
            </div>
          </div>
          {/* Staff Members list */}
          <div className="flex flex-col">
            {/* Table header */}
            <div className="grid grid-cols-[0.15fr_1fr_0.7fr_0.5fr] border-b pb-3">
              <div />
              <span className="font-bold text-xs text-light-black">
                Staff members
              </span>
              <span className="font-bold text-xs text-light-black">
                Designation
              </span>
              <span className="font-bold text-xs text-light-black">
                Reference
              </span>
            </div>
            {/* Table Body */}
            <div className="flex flex-col">
              {staffMembers?.map((staffMember) => {
                const isSelected = !!hiringTeamMembers?.find(
                  (item) => item?.userId === staffMember?._id
                );
                return (
                  <div
                    key={staffMember?._id}
                    onClick={() => handleAddOrRemoveStaff(staffMember?._id)}
                    className="grid grid-cols-[0.15fr_1fr_0.7fr_0.5fr] py-4 border-b cursor-pointer"
                  >
                    <div className="flex items-center justify-center">
                      <Checkbox checked={isSelected} className="w-5 h-5" />
                    </div>
                    <div className="flex items-center gap-2">
                      {staffMember?.profilePic ? (
                        <img
                          src={staffMember?.profilePic}
                          className="w-8 h-8"
                        />
                      ) : (
                        <div className="flex items-center justify-center w-8 h-8 rounded-full bg-gray-100 font-medium text-gray-500">
                          {staffMember?.firstName.charAt(0)}
                        </div>
                      )}
                      <span className="font-medium text-xs text-light-black">
                        {staffMember?.firstName} {staffMember?.lastName}
                      </span>
                    </div>
                    <span className="font-medium text-xs text-light-black flex items-center capitalize">
                      {HiringCompanyType[
                        staffMember?.hiringCompanyType
                      ].toLowerCase()}
                    </span>
                    <span className="font-medium text-xs text-light-black flex items-center">
                      {staffMember?.refNo}
                    </span>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default AddMembers;
